import MasterCrudPage from "@/components/MasterCrudPage";

export default function WhatsAppTemplates() {
  return (
    <MasterCrudPage
      endpoint="/whatsapp/templates"
      title="WhatsApp Templates"
      breadcrumbs={["WhatsApp Control", "Templates"]}
      testIdPrefix="wa-template"
      initialForm={{ is_active: true, language: "en", variables: [] }}
      columns={[
        { key: "template_name", label: "Name", width: 160 },
        { key: "template_type", label: "Type", width: 140 },
        { key: "title", label: "Title" },
        { key: "language", label: "Lang", width: 80 },
        { key: "is_active", label: "Status", render: r => r.is_active ?
          <span className="badge-base bg-emerald-50 text-emerald-700 border-emerald-200">Active</span> :
          <span className="badge-base bg-slate-100 text-slate-500 border-slate-200">Inactive</span> },
      ]}
      formFields={[
        { key: "template_name", label: "Template Name", required: true },
        { key: "template_type", label: "Type", required: true, placeholder: "task_assigned, approval_request..." },
        { key: "title", label: "Title", required: true },
        { key: "language", label: "Language", placeholder: "en" },
        { key: "message_body", label: "Message Body", type: "textarea", required: true,
          placeholder: "Use {{variable}} placeholders e.g. Hello {{name}}, task {{task_code}} is due." },
        { key: "_variables_str", label: "Variables (comma-separated)", placeholder: "name, task_code, due_date" },
        { key: "is_active", label: "Active", type: "checkbox" },
      ]}
      transformOnLoad={(r) => ({ ...r, _variables_str: (r.variables || []).join(", ") })}
      beforeSubmit={(p) => {
        const str = p._variables_str || "";
        p.variables = str.split(",").map(s => s.trim()).filter(Boolean);
        delete p._variables_str;
        return p;
      }}
    />
  );
}
